const headers = {
  name: "Branch Product",
  navigate: {
    tabs: [
      {
        name: "Import/Export",
        path: "/app/importexport",
      },
     
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
